import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Select, Switch, Button, message } from 'antd';

const { Option } = Select;

class PickAsset extends Component {
	componentDidMount() {
		const { asset } = this.props;
		const { setFieldsValue } = this.props.form;
		setFieldsValue({ asset: asset, isMainnet: true });
	}

	renderOptions = () => {
		const { coin } = this.props;
		const List = coin.map((item) => (
			<Option value={item.value}>
				{item.key} ({item.value.toUpperCase()})
			</Option>
		));
		return List;
	};

	handleSubmit = (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const body = {
			currency: getFieldValue('asset'),
			is_testnet: !getFieldValue('isMainnet')
		};
		if (body.is_testnet) {
			message.warn(
				'Testnet Wallet is unstable. You cannot create testnet wallet now.'
			);
			return;
		}
		if (body.currency === 'xmr') {
			message.info(
				'XMR requires custom setup. Please contact us at support@bitholla.com to setup your XMR wallet'
			);
			return;
		}
		this.props.onSubmit(body);
	};

	render() {
		const { getFieldDecorator, getFieldValue } = this.props.form;
		const isMainet = getFieldValue('isMainnet');
		return (
			<div>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item>
						<p>
							<b>Asset:</b>
						</p>
						{getFieldDecorator('asset')(
							<Select>{this.renderOptions()}</Select>
						)}
					</Form.Item>
					<Form.Item className="mainnet">
						<span
							className={isMainet ? 'switch-label' : 'switch-label on'}
						>
							Testnet
						</span>
						{getFieldDecorator('isMainnet', { valuePropName: 'checked' })(
							<Switch />
						)}
						<span
							className={isMainet ? 'switch-label on' : 'switch-label'}
						>
							<span>Mainnet</span>
							<i className="disclamers">
								Testnet coins are not real coins
								<br />
								and have no value and are simply
								<br />
								for the purpose of testing.
							</i>
						</span>
					</Form.Item>
					<Button type="primary" block htmlType="submit">
						Next
					</Button>
				</Form>
			</div>
		);
	}
}

const WrappedPickAsset = Form.create()(PickAsset);

const mapStateToProps = (state) => {
	return {
		coin: state.coin
	};
};

export default connect(mapStateToProps)(WrappedPickAsset);
